import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María García',
    age: '38 años',
    location: 'Buenos Aires',
    text: 'Bajé 8 kilos en 2 meses sin pasar hambre. Las recetas son riquísimas y súper fáciles de hacer. Mi familia ni se dio cuenta de que estábamos comiendo más saludable.',
    highlight: 'Bajé de peso sin dejar de comer rico. Nunca había sido tan fácil.'
  }, {
    name: 'Carolina Méndez',
    age: '45 años',
    location: 'Córdoba',
    text: 'Siempre arranqué dietas y las dejaba a la semana. Con este sistema llevo 3 meses y no lo siento como dieta. Es simplemente comer bien.',
    highlight: 'Esto no es una dieta, es un sistema que podés mantener.'
  }, {
    name: 'Luciana Torres',
    age: '33 años',
    location: 'Rosario',
    text: 'Como mamá de 3 chicos, no tengo tiempo para cocinar cosas complicadas. Este pack me salvó la vida. En 15 minutos tengo todo listo.',
    highlight: 'Por primera vez no tuve que pensar qué cocinar todos los días.'
  }, {
    name: 'Valentina Ruiz',
    age: '41 años',
    location: 'Mendoza',
    text: 'Lo mejor es el plan semanal. Ya no pierdo tiempo pensando qué cocinar. Abro el plan, compro lo que dice y listo. Bajé 5 kilos sin darme cuenta.',
    highlight: 'Bajé 5 kilos sin darme cuenta.'
  }, {
    name: 'Florencia López',
    age: '36 años',
    location: 'La Plata',
    text: 'Probé de todo: nutricionistas, apps, dietas de internet. Nada me funcionó hasta que encontré este megapack. Simple, práctico y con resultados reales.',
    highlight: 'Simple, práctico y con resultados reales.'
  }];
  return <section className="py-16 px-4 bg-gray-100" data-id="element-210">
      <div className="max-w-5xl mx-auto" data-id="element-211">
        <div className="text-center mb-12" data-id="element-212">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4 uppercase" data-id="element-213">
            💬 PERSONAS QUE YA ESTÁN CAMBIANDO SU ALIMENTACIÓN
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-214">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`bg-white p-6 rounded-2xl shadow-md border border-gray-200 flex flex-col ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-215">
              <div className="flex text-yellow-400 mb-4" data-id="element-216">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-217" />)}
              </div>
              <p className="text-lg text-gray-800 italic mb-4 flex-grow" data-id="element-218">
                "{t.text}"
              </p>
              <div className="bg-yellow-50 p-3 rounded-lg mb-4 border-l-4 border-yellow-400" data-id="element-219">
                <p className="font-bold text-gray-900 text-sm" data-id="element-220">
                  "{t.highlight}"
                </p>
              </div>
              <div className="mt-auto border-t border-gray-100 pt-4" data-id="element-221">
                <p className="font-black text-gray-900" data-id="element-222">{t.name}</p>
                <p className="text-sm text-gray-500 font-medium" data-id="element-223">
                  {t.age} • {t.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}